import { createContext } from 'react';
import {
  IArticle,
  IArticleFragment,
  ICategory,
  IHome,
  ISearchResult,
  IRelatedArticles,
} from '../types';

export type ISearchResultWithIndex = ISearchResult & { index: number };

/**
 * This just stores the current search result we are 'looking' at.
 */
export const SearchResultContext = createContext<
  ISearchResultWithIndex | undefined
>(undefined);

export const ArticleContext = createContext<IArticle | undefined>(undefined);

export const RelatedArticlesContext = createContext<
  IRelatedArticles | undefined
>(undefined);

export const ArticleFragmentContext = createContext<
  IArticleFragment | undefined
>(undefined);

export const HomeContext = createContext<IHome | undefined>(undefined);

export const CategoryContext = createContext<ICategory | undefined>(undefined);
